"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgInfinite(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M17.571 7.196a5.092 5.092 0 012.884.025l.242.082a5.047 5.047 0 012.868 2.683c.138.312.247.637.328.969a4.5 4.5 0 01.1.794 4.962 4.962 0 01-.694 2.819 4.993 4.993 0 01-2.374 2.062 5.302 5.302 0 01-1.162.336 4.56 4.56 0 01-1.122.052 6.146 6.146 0 01-2.281-.654 10.175 10.175 0 01-1.542-.961 22.902 22.902 0 01-1.711-1.433c-.232-.212-.53-.498-.824-.786L12 12.902l-.283.282c-.295.288-.592.574-.824.786-.55.501-1.114.987-1.711 1.433-.484.365-1 .687-1.542.96a6.146 6.146 0 01-2.281.655 4.56 4.56 0 01-1.122-.052 5.302 5.302 0 01-1.162-.336 4.993 4.993 0 01-2.374-2.062 4.962 4.962 0 01-.693-2.819 4.5 4.5 0 01.099-.794c.08-.332.19-.657.328-.97a5.047 5.047 0 012.868-2.682l.242-.082a5.092 5.092 0 012.884-.025c.75.233 1.465.567 2.126.992.556.366 1.089.766 1.596 1.197l.375.33c.374.33.972.91 1.474 1.408a42.88 42.88 0 011.474-1.409l.375-.329c.507-.431 1.04-.831 1.596-1.197a8.693 8.693 0 012.126-.992zm-13.366 1.4l-.223.06-.197.07a3.54 3.54 0 00-1.976 1.863 4.288 4.288 0 00-.235.684c-.038.174-.06.351-.068.56-.038.689.13 1.373.486 1.97a3.492 3.492 0 001.661 1.442c.268.112.547.192.838.241.248.043.5.055.74.036a4.656 4.656 0 001.732-.498 8.7 8.7 0 001.321-.824 21.2 21.2 0 001.599-1.34l.33-.309.553-.538-.194-.19a43.194 43.194 0 00-.92-.876l-.134-.12c-.56-.507-1.158-.97-1.775-1.377a7.15 7.15 0 00-1.727-.81 3.59 3.59 0 00-1.811-.043zm15.59 0a3.59 3.59 0 00-1.811.043 7.15 7.15 0 00-1.727.811c-.617.407-1.215.87-1.775 1.377l-.134.12-.27.251-.844.815.423.413.46.434a21.2 21.2 0 001.599 1.34c.42.317.86.59 1.321.824.545.28 1.13.447 1.732.498.24.019.492.007.74-.036.29-.049.57-.13.838-.24a3.492 3.492 0 001.661-1.444c.356-.596.524-1.28.486-1.97a3.122 3.122 0 00-.068-.56 4.288 4.288 0 00-.235-.683 3.537 3.537 0 00-2.173-1.932z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgInfinite;
exports.default = _default;